import { gql } from '@apollo/client';

export const DISMISS_PENDING_NOTIFICATION = gql`
  mutation dismissPendingNotification($guardianId: Int!) {
    dismissPendingNotification(guardianId: $guardianId) {
      guardianId
    }
  }
`;
